


























import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import { Prop, PropSync } from 'vue-property-decorator'
import Vue from 'vue'
import { AdminUserApiRoutes } from '@/modules/user/routes/admin-user.route'

@Component({
  components: {
    EntitySearchSelect
  }
})
export default class AdminUserSearch extends Vue {
  constructor(
    private readonly routes: AdminUserApiRoutes
  ) {
    super()
  }

  @PropSync('userId') userIdValue: number | string | number[]

  @Prop({ default: () => [] }) roles: string[]

  @Prop({ default: 3 }) minimumCharacter: number

  @Prop({ default: true }) lazy: boolean

  protected get params() {
    return {
      roles: this.roles
    }
  }

  private get route() {
    return this.routes.userSearch()
  }
}
